import React, { useState } from 'react';
import FileUploader from './FileUploader';

export default function FileUploaderWrapper({ 
  formFieldName = 'file', 
  onUploadedCallback, 
  onErrorCallback,
  existingFilename,
  existingUrl,
  ...props 
}) {
  const [uploadedBlobId, setUploadedBlobId] = useState('');
  const [uploadedFilename, setUploadedFilename] = useState('');
  const [fileContentType, setFileContentType] = useState('');

  const handleUploaded = (blobIds, filename, metadata = {}) => {
    const blobId = blobIds[0];
    setUploadedBlobId(blobId);
    setUploadedFilename(filename);
    setFileContentType(metadata.contentType || '');
    
    // Call custom callback if provided
    if (onUploadedCallback && window[onUploadedCallback]) {
      window[onUploadedCallback](blobIds, filename);
    }
  };

  const handleError = (error) => {
    console.error('Upload error:', error);
    
    // Call custom error callback if provided
    if (onErrorCallback && window[onErrorCallback]) {
      window[onErrorCallback](error);
    }
  };

  const isImageFile = (contentType, filename) => {
    if (contentType?.startsWith('image/')) return true;
    if (!contentType && filename) {
      const ext = filename.split('.').pop()?.toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
    }
    return false;
  };

  return (
    <div>
      <FileUploader 
        {...props}
        onUploaded={handleUploaded} 
        onError={handleError}
        existingFilename={existingFilename}
        existingUrl={existingUrl}
      />

      {uploadedBlobId && (
        <input 
          type="hidden" 
          name={formFieldName} 
          value={uploadedBlobId} 
        />
      )}

      {uploadedFilename && (
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
          ✅ Uploaded: {uploadedFilename}
        </div>
      )}

      {uploadedBlobId && isImageFile(fileContentType, uploadedFilename) && (
        <div style={{ marginTop: '10px' }}>
          <img 
            src={`/rails/active_storage/blobs/${uploadedBlobId}/${uploadedFilename}`} 
            alt="Uploaded image preview"
            style={{ maxWidth: '150px', maxHeight: '150px' }}
          />
        </div>
      )}
    </div>
  );
}
